import React, { useEffect, useState } from 'react';
import EmailEmptyState from './email_empty_state';
import EmailList from './email_list';

export default function EmailIndex() {
  const [emails, setEmails] = useState<Array<any>>([]);

  useEffect(() => {
    fetchEmails();
  }, []);

  const fetchEmails = () => {
    setEmails([]);
  };

  if (emails.length === 0) {
    return <EmailEmptyState />;
  }

  return <EmailList />;
}
